interface CardLinkFormErrorProps {
    testId: string
    message?: string
}

export const CardLinkFormErrorMessage = ({ testId, message }: CardLinkFormErrorProps) => {
    return (
        <div style={{
            all: 'unset',
            marginTop: '5px',
            padding: '0 10px',
            height: 'auto',
            fontSize: '15px',
            color: 'red',// @TODO get correct color
            display: 'block',
            lineHeight: '20px',
            transition: 'all .25s ease-out',
        }}
             data-testid={testId}
        >
            {message}
        </div>
    )
}